export default function () {
  const productivity_loss = document.querySelectorAll('.indirect_cost_productivity_loss_hover:not(.non-value-added)');
  const productivity_loss_non_value = document.querySelectorAll('.indirect_cost_productivity_loss_hover.non-value-added');
  const loss_due_to_mortality = document.querySelectorAll('.loss_due_to_mortality_hover:not(.non-value-added)');
  const loss_due_to_mortality_non_value = document.querySelectorAll('.loss_due_to_mortality_hover.non-value-added');
  const loss_due_to_morbidity = document.querySelectorAll('.loss_due_to_morbidity_hover:not(.non-value-added)');
  const loss_due_to_morbidity_non_value = document.querySelectorAll('.loss_due_to_morbidity_hover.non-value-added');
  const cost_health_expenditure = document.querySelectorAll('.cost_health_expenditure_hover:not(.non-value-added)');
  const cost_health_expenditure_non_value = document.querySelectorAll('.cost_health_expenditure_hover.non-value-added');
  const cost_of_illness = document.querySelectorAll('.detail-cost-of-illness:not(.non-value-added)');
  const cost_of_illness_non_value = document.querySelectorAll('.detail-cost-of-illness.non-value-added');
  const cost_of_illness_chart = document.querySelectorAll('.cost_of_illness');

  const hover_roductivity_loss = document.querySelectorAll('.hover-productivity-Loss');
  const hover_expenditure = document.querySelectorAll('.chart-indicator-expenditure');
  const productivity_Loss_mortality = document.querySelectorAll('.productivity-Loss-mortality');
  const productivity_Loss_morbidity = document.querySelectorAll('.productivity-Loss-morbidity');

  // Desktop functionality: Mouseover and Mouseleave
  productivity_loss.forEach(item => {
    item.addEventListener('mouseover', () => {
      hover_roductivity_loss.forEach(el => el.style.opacity = 1);
      hover_expenditure.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
      cost_of_illness.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      hover_roductivity_loss.forEach(el => el.style.opacity = 0);
      hover_expenditure.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 1);
      cost_health_expenditure.forEach(el => el.style.opacity = 1);
      cost_of_illness.forEach(el => el.style.opacity = 1);
    });
  });

  productivity_loss_non_value.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#1c77aa');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });
  });

  loss_due_to_mortality.forEach(item => {
    item.addEventListener('mouseover', () => {
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
      productivity_loss.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
      cost_of_illness.forEach(el => el.style.opacity = 0.15);
      hover_expenditure.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 1);
      productivity_loss.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 1);
      cost_health_expenditure.forEach(el => el.style.opacity = 1);
      cost_of_illness.forEach(el => el.style.opacity = 1);
      hover_expenditure.forEach(el => el.style.opacity = 1);
    });
  });

  loss_due_to_mortality_non_value.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#295e5b');
      productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });
  });

  loss_due_to_morbidity.forEach(item => {
    item.addEventListener('mouseover', () => {
      productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
      productivity_loss.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
      cost_of_illness.forEach(el => el.style.opacity = 0.15);
      hover_expenditure.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      productivity_Loss_mortality.forEach(el => el.style.opacity = 1);
      productivity_loss.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality.forEach(el => el.style.opacity = 1);
      cost_health_expenditure.forEach(el => el.style.opacity = 1);
      cost_of_illness.forEach(el => el.style.opacity = 1);
      hover_expenditure.forEach(el => el.style.opacity = 1);
    });
  });

  loss_due_to_morbidity_non_value.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#9f7e55');
      productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });
  });

  cost_health_expenditure.forEach(item => {
    item.addEventListener('mouseover', () => {
      productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
      productivity_loss.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
      cost_of_illness.forEach(el => el.style.opacity = 0.15);
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      productivity_Loss_mortality.forEach(el => el.style.opacity = 1);
      productivity_loss.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 1);
      cost_of_illness.forEach(el => el.style.opacity = 1);
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 1);
    });
  });

  cost_health_expenditure_non_value.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#17aea5');
      productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });
  });

  cost_of_illness.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.opacity = 1);
      productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
      hover_expenditure.forEach(el => el.style.opacity = 0.15);
      productivity_loss.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.opacity = 0);
      productivity_Loss_mortality.forEach(el => el.style.opacity = 1);
      hover_expenditure.forEach(el => el.style.opacity = 1);
      productivity_loss.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity.forEach(el => el.style.opacity = 1);
      cost_health_expenditure.forEach(el => el.style.opacity = 1);
      productivity_Loss_morbidity.forEach(el => el.style.opacity = 1);
    });
  });

  cost_of_illness_non_value.forEach(item => {
    item.addEventListener('mouseover', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });

    item.addEventListener('mouseleave', () => {
      cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
      productivity_loss_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
      loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
      cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
      cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
    });
  });

  // Mobile functionality: Click
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  if (isMobile) {
    productivity_loss.forEach(item => {
      item.addEventListener('click', () => {
        hover_roductivity_loss.forEach(el => el.style.opacity = 1);
        hover_expenditure.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
        cost_of_illness.forEach(el => el.style.opacity = 0.15);
      });
    });

    productivity_loss_non_value.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#1c77aa');
        productivity_loss_non_value.forEach(el => el.style.opacity = 1);
        loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
        cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
      });
    });

    loss_due_to_mortality.forEach(item => {
      item.addEventListener('click', () => {
        productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
        productivity_loss.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
        cost_of_illness.forEach(el => el.style.opacity = 0.15);
        hover_expenditure.forEach(el => el.style.opacity = 0.15);
      });
    });

    loss_due_to_mortality_non_value.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#295e5b');
        productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 1);
        loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
        cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
      });
    });

    loss_due_to_morbidity.forEach(item => {
      item.addEventListener('click', () => {
        productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
        productivity_loss.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
        cost_of_illness.forEach(el => el.style.opacity = 0.15);
        hover_expenditure.forEach(el => el.style.opacity = 0.15);
      });
    });

    loss_due_to_morbidity_non_value.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#9f7e55');
        productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 1);
        cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
        cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
      });
    });

    cost_health_expenditure.forEach(item => {
      item.addEventListener('click', () => {
        productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
        productivity_loss.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
        cost_of_illness.forEach(el => el.style.opacity = 0.15);
        productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
      });
    });

    cost_health_expenditure_non_value.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#17aea5');
        productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure_non_value.forEach(el => el.style.opacity = 1);
        cost_of_illness_non_value.forEach(el => el.style.opacity = 0.15);
      });
    });

    cost_of_illness.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.opacity = 1);
        productivity_Loss_mortality.forEach(el => el.style.opacity = 0.15);
        hover_expenditure.forEach(el => el.style.opacity = 0.15);
        productivity_loss.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure.forEach(el => el.style.opacity = 0.15);
        productivity_Loss_morbidity.forEach(el => el.style.opacity = 0.15);
      });
    });

    cost_of_illness_non_value.forEach(item => {
      item.addEventListener('click', () => {
        cost_of_illness_chart.forEach(el => el.style.backgroundColor = '#232323');
        productivity_loss_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_mortality_non_value.forEach(el => el.style.opacity = 0.15);
        loss_due_to_morbidity_non_value.forEach(el => el.style.opacity = 0.15);
        cost_health_expenditure_non_value.forEach(el => el.style.opacity = 0.15);
        cost_of_illness_non_value.forEach(el => el.style.opacity = 1);
      });
    });

  }
}
